export const ALGOLIA_SEARCH_ATTRIBUTION_KEY = 'algoliaSearchAttribution';

function normalizeAttributionValue(value) {
  if (value == null || value === '') {
    return null;
  }

  return value;
}

export function buildAlgoliaSearchAttribution(payload = {}) {
  const objectID = normalizeAttributionValue(payload.objectID);
  const index = normalizeAttributionValue(payload.index || payload.__indexName || payload.indexName);
  const queryID = normalizeAttributionValue(payload.queryID || payload.__queryID);
  const position = normalizeAttributionValue(payload.position || payload.__position);

  if (!objectID || !index) {
    return null;
  }

  return {
    objectID,
    index,
    queryID,
    position: position == null ? null : Number(position),
  };
}

export function setAlgoliaSearchAttribution(payload = {}) {
  const attribution = buildAlgoliaSearchAttribution(payload);

  if (!attribution || typeof window === 'undefined' || !window.localStorage) {
    return null;
  }

  window.localStorage.setItem(ALGOLIA_SEARCH_ATTRIBUTION_KEY, JSON.stringify(attribution));
  return attribution;
}

export function getAlgoliaSearchAttribution() {
  if (typeof window === 'undefined' || !window.localStorage) {
    return null;
  }

  const rawValue = window.localStorage.getItem(ALGOLIA_SEARCH_ATTRIBUTION_KEY);

  if (!rawValue) {
    return null;
  }

  try {
    return JSON.parse(rawValue);
  } catch (error) {
    window.localStorage.removeItem(ALGOLIA_SEARCH_ATTRIBUTION_KEY);
    return null;
  }
}

export function clearAlgoliaSearchAttribution() {
  if (typeof window === 'undefined' || !window.localStorage) {
    return;
  }

  window.localStorage.removeItem(ALGOLIA_SEARCH_ATTRIBUTION_KEY);
}

function normalizeProductId(product) {
  if (!product) {
    return null;
  }

  const candidates = [
    product.id,
    product.productId,
    product.product_id,
    product?.product?.id,
    product?.cprops?.productDetails?.id,
  ];

  const match = candidates.find((value) => value != null && value !== '');

  return match == null ? null : String(match);
}

export function getMatchingAlgoliaSearchAttribution(product) {
  const attribution = getAlgoliaSearchAttribution();

  if (!attribution || !product) {
    return null;
  }

  const objectID = String(attribution.objectID);

  const productId = normalizeProductId(product);
  if (productId && objectID === productId) {
    return attribution;
  }

  const variants = product.variants || (product.product && product.product.variants) || [];
  if (variants.some((v) => v && String(v.id) === objectID)) {
    return attribution;
  }

  return null;
}

export function buildAlgoliaAddToCartTrackingPayload({
  product,
  variantId = null,
  quantity = null,
  attribution = null,
} = {}) {
  const matchedAttribution = attribution || getMatchingAlgoliaSearchAttribution(product);

  if (!matchedAttribution) {
    return null;
  }

  return {
    ...matchedAttribution,
    productId: normalizeProductId(product),
    variantId: variantId == null ? null : String(variantId),
    quantity: quantity == null ? null : Number(quantity),
  };
}

export function initAlgoliaSearchAttributionGlobals() {
  if (typeof window === 'undefined') {
    return;
  }

  window.setAlgoliaSearchAttribution = setAlgoliaSearchAttribution;
}
